import React, {
  useEffect,
} from "react";

import "@/App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { Toaster } from "sonner";

import {
  CartProvider,
} from "@/context/CartContext";

import {
  AuthProvider,
} from "@/context/AuthContext";

import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetails from "@/pages/ProductDetails";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

/* =========================================================
   SCROLL TO TOP
========================================================= */

function ScrollToTop() {
  const {
    pathname,
  } = useLocation();

  useEffect(() => {
    window.scrollTo(
      0,
      0
    );
  }, [pathname]);

  return null;
}

/* =========================================================
   STOREFRONT LAYOUT
========================================================= */

function Storefront({
  children,
}) {
  return (
    <SmoothScroll>

      <Navbar />

      {/*
       * IMPORTANT:
       * CartDrawer is INSIDE CartProvider.
       *
       * CartDrawer uses useCart(), so it receives
       * the exact same cart state as Navbar.
       */}

      <CartDrawer />

      {children}

      <Footer />

    </SmoothScroll>
  );
}

/* =========================================================
   APP
========================================================= */

export default function App() {
  return (
    <div className="App">

      <div className="noise-overlay" />

      <BrowserRouter>

        <AuthProvider>

          <CartProvider>

            <ScrollToTop />

            <Routes>

              {/* =========================================
                  HOME
              ========================================= */}

              <Route
                path="/"
                element={
                  <Storefront>
                    <Home />
                  </Storefront>
                }
              />

              {/* =========================================
                  SHOP
              ========================================= */}

              <Route
                path="/shop"
                element={
                  <Storefront>
                    <Shop />
                  </Storefront>
                }
              />

              {/* =========================================
                  PRODUCT DETAILS
              ========================================= */}

              <Route
                path="/product/:id"
                element={
                  <Storefront>
                    <ProductDetails />
                  </Storefront>
                }
              />

              {/* =========================================
                  CART
              ========================================= */}

              <Route
                path="/cart"
                element={
                  <Storefront>
                    <Cart />
                  </Storefront>
                }
              />

              {/* =========================================
                  CHECKOUT
              ========================================= */}

              <Route
                path="/checkout"
                element={
                  <Storefront>
                    <Checkout />
                  </Storefront>
                }
              />

              {/* =========================================
                  ORDER SUCCESS
              ========================================= */}

              <Route
                path="/order-success"
                element={
                  <Storefront>
                    <OrderSuccess />
                  </Storefront>
                }
              />

              {/* =========================================
                  ADMIN LOGIN
              ========================================= */}

              <Route
                path="/admin/login"
                element={
                  <AdminLogin />
                }
              />

              {/* =========================================
                  ADMIN DASHBOARD
              ========================================= */}

              <Route
                path="/admin"
                element={
                  <AdminDashboard />
                }
              />

            </Routes>

            <Toaster
              position="top-center"
              richColors
            />

          </CartProvider>

        </AuthProvider>

      </BrowserRouter>

    </div>
  );
}
